import type { FC, ReactNode } from 'react';
import { Message } from '@gonfalon/messages/Message';
import { Icon } from '@launchpad-ui/icons';

import {
  evaluation,
  evaluationChildren,
  evaluationGrade,
  evaluationHead,
  evaluationIcon,
  evaluationNotes,
  evaluationScore,
} from '../../internal/components/conversation/ConversationChrome.css';

export interface EvaluationBannerProps {
  gradeLabel: string;
  notes?: string;
  overallScore?: number;
  children?: ReactNode;
  className?: string;
}

/**
 * Conversation-level evaluation chrome. Match Figma’s green sparkle + grade + notes;
 * span keeps score and dimension drill-in via optional score/`children`.
 */
export const EvaluationBanner: FC<EvaluationBannerProps> = ({
  gradeLabel,
  notes,
  overallScore,
  children,
  className,
}) => (
  <div className={[evaluation, className].filter(Boolean).join(' ')}>
    <div className={evaluationHead}>
      <Icon name="sparkle" size="small" className={evaluationIcon} />
      <span className={evaluationGrade}>
        <Message id="vega.conversation.evaluationGrade" values={{ grade: gradeLabel }} />
      </span>
      {overallScore != null ? <span className={evaluationScore}>{overallScore}</span> : null}
    </div>
    {notes ? <p className={evaluationNotes}>{notes}</p> : null}
    {children ? <div className={evaluationChildren}>{children}</div> : null}
  </div>
);
